(function() {
  'use strict';

  angular
    .module('protein', [
    	// Generated modules
        'ngAnimate', 
    	'ngCookies', 
    	'ngSanitize', 
    	'ngResource', 
    	'ngRoute', 
        'ngCachedResource',
        'ui.router',
        // Pagination
        'infinite-scroll',
        // Smooth scroll
        'duScroll',
        // Addthis for angular
        'sn.addthis',
        // Loading bar
        'angular-loading-bar',
        'angular-storage',
        'truncate',
        // Page titles & Meta data
        'viewhead',
        'ng-showdown',
        'contentful',
        'slickCarousel',
        'angular-google-analytics'
    ]);

})();

angular.module('protein')

	.controller('StaticPagesHoldingController', function($scope, $rootScope, $stateParams, contentful, $filter) {

		// Meta data
		$rootScope.pageTitle = "Welcome";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "/";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesHomeController', function($scope, $rootScope, $stateParams, contentful, $filter) {

		$scope.page = 'home';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entries('content_type=homePage&limit=1&order=-sys.updatedAt&locale=*')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
					$scope.loading = false;    	
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "Welcome";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "/";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesAboutController', function($scope, $rootScope, $stateParams, contentful) {

		
		$scope.page = 'about';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entries('content_type=aboutPage&limit=1&order=-sys.updatedAt&locale=*')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
					$scope.loading = false;    	
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "About";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "about";
		$rootScope.pageImage = "";

	})

	
	.controller('StaticPagesReservationsController', function($scope, $rootScope, $stateParams, $timeout, contentful) {

		
		$scope.page = 'reservations';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entries('content_type=contactPage&limit=2&order=-sys.createdAt&locale=*')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
					$scope.loading = false;    	
		        }
	      	);


		// Meta data
		$rootScope.pageTitle = "Reservations";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "reservations";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesContactController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'contact';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entries('content_type=contactPage&limit=2&order=-sys.createdAt&locale=*')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[1].fields;
					$scope.loading = false;    	
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "Contact";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "contact";
		$rootScope.pageImage = "";

	})


	.controller('StaticPagesGalleryController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'gallery';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entries('content_type=galleryPage&limit=1&order=-sys.updatedAt&locale=*')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
					$scope.loading = false;    	
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "Gallery";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "gallery";
		$rootScope.pageImage = "";

	})


	.controller('StaticPagesMenuController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'menu';
		$scope.loading = true;

		$scope.selectedMenu = 'menu1';

		$scope.selectMenu = function(menu) {
			$scope.selectedMenu = menu;
		}

      	// Fetch entries from API
    	contentful
      		.entries('content_type=menu&limit=1&order=-sys.updatedAt&locale=*')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
		          	console.log($scope.entry);
					$scope.loading = false;    	
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "Menu";
		$rootScope.pageDescription = "See today's menu";
		$rootScope.pageUrl = "menu";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesNewsletterController', function($scope, $rootScope, $stateParams) {

		// Meta data
		$rootScope.pageTitle = "Newsletter";
		$rootScope.pageDescription = "Japanese restaurant specialising in traditional handmade soba noodles";
		$rootScope.pageUrl = "newsletter";
		$rootScope.pageImage = "";

	})

	;
angular.module('protein')
  	
	.controller('AppController', function($scope, $rootScope, $document, $cookies, $window, $timeout, $location, $stateParams, $state) {
		
		// Current year
		$scope.date = new Date();
		$scope.year = new Date().getFullYear();

		$scope.language = 'english';

		$scope.switchLanguage = function(e) {
			if (e == 0) {
				$scope.language = 'english';
			} else {
				$scope.language = 'japanese';
			}
		};
		
		// Scroll to top of page when hitting up arrow
		$scope.topScroll = function(e) {
			$document.scrollTopAnimated(0, 1000);
		};

	    // Scroll to top on page load
		$scope.$on('$viewContentLoaded', function(){
			$document.scrollTopAnimated(0, 100);
		});

		// Change page values
		$rootScope.$on('$locationChangeStart', function(event, newState, oldUrl){			
			
			$scope.mobileMenu = false;

		});



		// Newsletter signup
		$scope.showModal = false;
		var month = new Date(+new Date + 2.592e+9);

		$timeout(function() {
			var show_modal = $cookies.get('YenSignup');
			if (show_modal == undefined) {
				$scope.showModal = true;
			}
			
		}, 5000);

		$scope.hideModal = function() {
			$scope.showModal = false;
			$cookies.put('YenSignup', false, { expires: month });
		}



	});
(function() {
  'use strict';

  angular
    .module('protein');
    
})();

(function() {
  'use strict';

  angular
    .module('protein')
    
    // The CMS API 
    // .factory('Api', function($cachedResource, Endpoint) {
    //     return function(key) {
    //         key = key.join? key.join('/'):key;
    //         return $cachedResource(key, Endpoint + key + '/:id.json', {id: "@id"}, {
    //             'update': {method: 'PUT'}
    //         });
    //     };
    // })

    // Trusted hosts [ie, a url from youtube, vimeo hosted files etc]
    .filter('trustUrl', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    })

    // Trust embed 
    .filter('trustEmbed', function ($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    })

    // Capitalise text
    .filter('capitalize', function() {
        return function(input, all) {
            return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
        };
    })

    // Replace hyphens with space
    .filter('space', function() {
        return function(str) {
            return str.replace(/-/g, ' ');
        };
    })


    // Chop text string if longer than defined length
    .filter('strLimit', ['$filter', function($filter) {
        return function(input, limit) {
            if (! input) return;
            if (input.length <= limit) {
                return input;
            }
            return $filter('limitTo')(input, limit) + '...';
        };

    }])



    ;

})();



(function() {
  'use strict';

  angular
    .module('protein')
    .config(routeConfig)
    
	.config(function ($sceDelegateProvider, contentfulProvider, AnalyticsProvider) {
      	
	    // Trust these urls
	    $sceDelegateProvider.resourceUrlWhitelist([
     		'self',
     		'*://www.youtube.com/**',
     		'*://www.vimeo.com/**',
     		'*://www.shopify.com/**',
        '*://www.mixcloud.com/**',
   		])

      // Contentful API
      contentfulProvider.setOptions({
        space: 'cwe8rutcukdg',
        accessToken: '04472322e858af40d52277a61e180642fc6a0ee8464a029da40e43fa32596f33'
      });

      // Google analytics
      AnalyticsProvider.setAccount('UA-102227823-1');

	})


  .run(function(Analytics) { })


  function routeConfig($stateProvider, $locationProvider, $urlRouterProvider) {

    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');
    
    // Routes for the site
    $stateProvider

      // .state('holding', {
      //   url: '/',
      //   templateUrl: 'templates/views/static_pages/holding.html',
      //   controller: 'StaticPagesHoldingController'
      // })

      .state('home', {
        url: '/',
        templateUrl: 'templates/views/static_pages/home.html',
        controller: 'StaticPagesHomeController'
      })

      .state('about', {
        url: '/about',
        templateUrl: 'templates/views/static_pages/about.html',
        controller: 'StaticPagesAboutController'
      })

      .state('menu', {
        url: '/menu',
        templateUrl: 'templates/views/static_pages/menu.html',
        controller: 'StaticPagesMenuController'
      })

      .state('reservations', {
        url: '/reservations',
        templateUrl: 'templates/views/static_pages/reservations.html',
        controller: 'StaticPagesReservationsController'
      })

      .state('contact', {
        url: '/contact',
        templateUrl: 'templates/views/static_pages/contact.html',
        controller: 'StaticPagesContactController'
      })

      .state('gallery', {
        url: '/gallery',
        templateUrl: 'templates/views/static_pages/gallery.html',
        controller: 'StaticPagesGalleryController'
      })

      .state('newsletter', {
        url: '/newsletter',
        templateUrl: 'templates/views/static_pages/newsletter.html',
        controller: 'StaticPagesNewsletterController'
      })


      ;
  }



})();

(function() {
  'use strict';

  angular
    .module('protein')

    .directive('mdHeader', function mdHeader() {
        var mdHeader = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/header.html'
        };
        return mdHeader;
    })

    .directive('loading', function loading() {
        var loading = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/loading.html'
        };
        return loading;
    })

    .directive('yenLogo', function yenLogo() {
        var yenLogo = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/yen-logo.html'
        };
        return yenLogo;
    })

    .directive('locale', function locale() {
        var locale = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/locale.html'
        };
        return locale;
    })

    .directive('homePageNav', function homePageNav() {
        var homePageNav = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/homepage-nav.html'
        };
        return homePageNav;
    })

    .directive('newsletterModal', function newsletterModal() {
        var newsletterModal = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/newsletter-modal.html'
        };
        return newsletterModal;
    })

    .directive('mdFooter', function footer() {
        var footer = {
          	restrict: 'E',
          	templateUrl: 'templates/views/shared/footer.html'
        };
        return footer;
    })


    // Smooth transition between pages
    .directive('smoothLoad', function ($window, $rootScope, $timeout) {
        return function() {

            $rootScope.$on('$stateChangeStart', function(){ 
                $('body').addClass('load');
            })

            $rootScope.$on('$stateChangeSuccess', function(){
                $('body').removeClass('load');
            })

        };
    })

    // Add target blank to all links in CMS rendered content
    .directive('linkAway', function ($timeout) {
        return function() {
            
            $timeout(function () {
                $('.text-block a').attr('target', '_blank');
            }, 500);

        };
    })



})();






















angular.module("protein").run(["$templateCache", function($templateCache) {$templateCache.put("templates/views/shared/footer.html","<newsletter-modal></newsletter-modal><footer role=\"contentInfo\"><p class=\"uppercase\"><a class=\"underline-link\" ng-href=\"mailto:cristoforo.santini@joseph.co.uk\"><span ng-if=\"language == &#39;english&#39;\">Work with us</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">採用に関すお問合せ</span></a></p><p>+44 20 3915 6976 — 190 STRAND – 5 ARUNDEL STREET – LONDON – WC2R 3DX</p><a class=\"patio\" href=\"https://patio.cool\" target=\"_blank\"><span>Patio</span> <span>{{year}}</span></a></footer>");
$templateCache.put("templates/views/shared/header.html","<header role=\"banner\"><locale class=\"show-on-mobile\"></locale><yen-logo></yen-logo><div class=\"hide-on-mobile\"><ul class=\"navigation header-font\" id=\"primary-nav\"><li><a href=\"/\" ng-class=\"{&#39;active&#39; : page == &#39;home&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Home</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ホーム</span></a></li><li><a href=\"/menu\" ng-class=\"{&#39;active&#39; : page == &#39;menu&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Menu</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">メニュー</span></a></li><li><a href=\"/contact\" ng-class=\"{&#39;active&#39; : page == &#39;contact&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Contact</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">連絡先</span></a></li><li><a href=\"/about\" ng-class=\"{&#39;active&#39; : page == &#39;about&#39;}\"><span ng-if=\"language == &#39;english&#39;\">About</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">レストラン円について</span></a></li><li><a href=\"/reservations\" ng-class=\"{&#39;active&#39; : page == &#39;reservations&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Reservations</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ご予約</span></a></li><li><a href=\"/gallery\" ng-class=\"{&#39;active&#39; : page == &#39;gallery&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Gallery</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ギャラリー</span></a></li></ul><div id=\"right-nav\"><div id=\"social-icons\"><a class=\"instagram social-icon\" ng-href=\"https://www.instagram.com/yenrestaurant\" style=\"background-image: url(/assets/images/instagram.svg)\" target=\"_blank\"></a><a class=\"twitter social-icon\" ng-href=\"https://twitter.com/yenrestaurant\" style=\"background-image: url(/assets/images/twitter.svg)\" target=\"_blank\"></a><a class=\"facebook social-icon\" ng-href=\"https://www.facebook.com/YenRestaurantLondon/\" style=\"background-image: url(/assets/images/facebook.svg)\" target=\"_blank\"></a></div><locale></locale></div></div><div class=\"show-on-mobile float-right\"><div class=\"click\" id=\"menu-trigger\" ng-click=\"mobileMenu=!mobileMenu\"><i class=\"material-icons\">menu</i></div></div></header><nav class=\"slide\" id=\"mobile-menu\" ng-show=\"mobileMenu\" role=\"banner\"><div class=\"click\" id=\"close-trigger\" ng-click=\"mobileMenu=!mobileMenu\"><i class=\"material-icons\">close</i></div><yen-logo></yen-logo><ul class=\"mobile-navigation header-font\"><li><a href=\"/\" ng-class=\"{&#39;active&#39; : page == &#39;home&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Home</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ホーム</span></a></li><li><a href=\"/menu\" ng-class=\"{&#39;active&#39; : page == &#39;menu&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Menu</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">メニュー</span></a></li><li><a href=\"/contact\" ng-class=\"{&#39;active&#39; : page == &#39;contact&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Contact</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">連絡先</span></a></li><li><a href=\"/about\" ng-class=\"{&#39;active&#39; : page == &#39;about&#39;}\"><span ng-if=\"language == &#39;english&#39;\">About</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">レストラン円について</span></a></li><li><a href=\"/reservations\" ng-class=\"{&#39;active&#39; : page == &#39;reservations&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Reservations</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ご予約</span></a></li><li><a href=\"/gallery\" ng-class=\"{&#39;active&#39; : page == &#39;gallery&#39;}\"><span ng-if=\"language == &#39;english&#39;\">Gallery</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ギャラリー</span></a></li></ul><ul class=\"mobile-navigation-small header-font\"><li><a href=\"/contact\"><span ng-if=\"language == &#39;english&#39;\">Map</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">地図</span></a></li><li><a href=\"/\" target=\"_blank\">Instagram</a></li><li><a href=\"/\" target=\"_blank\">Twitter</a></li><li><a href=\"/contact\">Careers</a></li></ul></nav>");
$templateCache.put("templates/views/shared/homepage-nav.html","<div class=\"columns twelve center hide-on-mobile\" id=\"homepage-nav\" ng-hide=\"show\"><a class=\"page-link columns four no-margin\" ng-href=\"/menu\"><h2 class=\"underline-title\">Menu</h2><p>Click to see</p></a><a class=\"page-link columns four no-margin\" ng-href=\"/reservations\"><h2 class=\"underline-title\">Reservations</h2><p>Book a table</p></a><a class=\"page-link columns four no-margin\" ng-href=\"/contact\"><h2 class=\"underline-title\">Contact us</h2><p>Get in touch</p></a></div>");
$templateCache.put("templates/views/shared/loading.html","<div class=\"loading\" ng-if=\"loading\"><div class=\"rolling\"></div></div>");
$templateCache.put("templates/views/shared/locale.html","<ul class=\"header-font\" id=\"language-trigger\"><li class=\"click\" ng-class=\"{&#39;active&#39; : language == &#39;english&#39;}\" ng-click=\"switchLanguage(0)\">EN</li><span>|</span><li class=\"click japanese\" ng-class=\"{&#39;active&#39; : language == &#39;japanese&#39;}\" ng-click=\"switchLanguage(1)\">日本語</li></ul>");
$templateCache.put("templates/views/shared/newsletter-modal.html","<div class=\"animate-slide\" id=\"newsletter-modal\" ng-show=\"showModal\"><i class=\"material-icons close-btn click\" ng-click=\"hideModal()\">close</i><h3 class=\"header-font\"><span ng-if=\"language == &#39;english&#39;\">Would you like to receive our newsletter?</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ニューズレターをご希望の方</span></h3><div id=\"mc_embed_signup\"><form action=\"//yen-london.us16.list-manage.com/subscribe/post?u=4c0fdab035ec4be075f5a6882&amp;amp;id=27805fc71c\" class=\"validate\" id=\"mc-embedded-subscribe-form\" method=\"post\" name=\"mc-embedded-subscribe-form\" novalidate=\"\" target=\"_blank\"><div id=\"mc_embed_signup_scroll\"><input class=\"email\" id=\"mce-EMAIL\" name=\"EMAIL\" placeholder=\"Email address\" required=\"\" type=\"email\" value=\"\"><div class=\"clear\" id=\"mce-responses\"><div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div></div><div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"></div><input class=\"button\" id=\"mc-embedded-subscribe\" name=\"subscribe\" type=\"submit\" value=\"Sign up\"></div></form></div><div class=\"clearfix\"></div><h4 class=\"click header-font\" ng-click=\"hideModal()\"><span ng-if=\"language == &#39;english&#39;\">No thanks</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">希望しません</span></h4></div>");
$templateCache.put("templates/views/shared/yen-logo.html","<a class=\"svg\" href=\"/\"><svg enable-background=\"new 0 0 86 92\" height=\"92px\" id=\"logo\" version=\"1.1\" viewbox=\"0 0 86 92\" width=\"86px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><g transform=\"translate(0.000000,92.000000) scale(0.100000,-0.100000)\"><path d=\"M297.002,900c-69.004-37.998-180-164.999-203.003-232.997C52.002,542.999,26.001,412.999,26.001,317.999 c0-90,1.001-98.994,23.999-122.998c48.999-52.002,123.999-72.998,137.002-37.998c3.999,8.994-6.001,50.996-20,92.002 c-32.002,90-49.004,237.998-26.001,228.994c7.998-2.998,38.999-12.998,70-22.998l56.001-17.998L372.998,474 c77.998,27.002,122.002,36.001,169.004,36.001c35.996,0,68.994,5,75.996,12.002c35,35-13.994,101.997-57.002,78.999 C550,595.001,514.004,590.001,480,590.001h-62.002l4.004,47.998C425,664,433.999,701.002,442.998,721.002 c17.998,41.001,7.002,76.001-31.997,94.999c-18.999,10-32.002,7.998-73.003-8.998c-65.996-27.002-82.998-60-81.997-155 c1.001-70,0-73.003-25-78.003c-13.999-2.998-33.003-7.998-41.001-10c-7.998-1.997-21.001,0-28.999,5 c-18.999,12.002-2.002,93.999,37.998,177.002C256.001,865,335,897.998,445.996,846.001c59.004-27.002,167.002-131,207.002-198.998 C700,567.999,702.002,395.997,655,414.005c-7.002,1.992-20-3.008-29.004-13.008c-16.992-18.994-21.992-70.996-5.996-70.996 c5,0,7.002-5.996,4.004-14.004c-3.008-7.998-1.006-16.992,3.994-20c6.006-2.998,12.998,1.006,16.006,9.004 c3.994,12.998,8.994,12.998,25,2.998C700,289.005,735.996,320.001,755,382.003c19.004,63.994,19.004,122.998,0,211.997 c-25.996,123.999-100,210-240.996,279.999C417.998,922.998,352.998,930,297.002,900z\" fill=\"#002A44\"></path><path d=\"M420,170.997v-60.996h-35c-35,0-35,0-35,42.998c0,24.004-2.998,47.002-7.002,50C330,217.003,310,185.997,310,150.001 c0-62.998,6.001-70,61.001-70c36.997,0,48.999-4.004,48.999-15c0-12.002-18.999-15-108.999-15c-70,0-112.002-4.004-117.002-10.996 C181.001,17.003,217.002,10.001,330,12.003l115,2.998v104.004c0,75-4.004,105.996-12.002,108.994 C422.998,230.997,420,215.001,420,170.997z\" fill=\"#002A44\"></path><path d=\"M497.002,222.999c-4.004-2.998-7.002-47.998-7.002-97.998c0-67.002,4.004-95.996,14.004-104.004 c8.994-6.992,41.992-10.996,86.992-8.994c61.006,2.002,74.004,5.996,77.002,20.996s-5,17.002-67.002,17.002H530v30 c0,27.998,2.002,30,40,30c29.004,0,40,4.004,40,15s-10.996,15-40,15c-35.996,0-40,2.998-40,25c0,24.004,2.998,25,54.004,25 c50,0,85.996,17.002,68.994,32.998C645,232.003,505,232.003,497.002,222.999z\" fill=\"#002A44\"></path><path d=\"M694.004,217.003c-9.004-24.004,0-202.002,10.996-200c5.996,2.002,10.996,40.996,12.998,87.998l2.998,85H770h49.004 l2.998-85C825.996-17.997,845-2.997,845,122.999v102.002l-72.998,2.998C717.998,230.001,697.998,227.003,694.004,217.003z\" fill=\"#002A44\"></path></g></svg></a>");
$templateCache.put("templates/views/static_pages/about.html","<md-header></md-header><div class=\"page\" id=\"about-page\"><loading></loading><div class=\"wrapper\" ng-if=\"!loading\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery[&#39;en-GB&#39;]\"><img alt=\"{{i.fields.title[&#39;en-GB&#39;]}}\" ng-src=\"{{i.fields.file[&#39;en-GB&#39;].url}}?w=1500\"><div class=\"slide-count-wrap\"><span ng-if=\"entry.imageGallery[&#39;en-GB&#39;].length &gt; 1\">{{$index + 1}} / {{entry.imageGallery[&#39;en-GB&#39;].length}}</span></div><div class=\"caption\" ng-bind-html=\"i.fields.description[&#39;en-GB&#39;]\" ng-if=\"i.fields.description\"></div></div></slick></div><div class=\"wrapper text-wrapper tiny-wrapper\"><div class=\"text-block\"><h1 class=\"header-font\"><span ng-if=\"language == &#39;english&#39;\">About Yen</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">レストラン円について</span></h1><div link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;en-GB&#39;]\" ng-if=\"language == &#39;english&#39;\"></div><div class=\"japanese\" link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;ja&#39;]\" ng-if=\"language == &#39;japanese&#39;\"></div></div></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/contact.html","<md-header></md-header><div class=\"page\" id=\"contact-page\"><loading></loading><div class=\"wrapper\" ng-if=\"!loading\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery[&#39;en-GB&#39;]\"><img alt=\"{{i.fields.title[&#39;en-GB&#39;]}}\" ng-src=\"{{i.fields.file[&#39;en-GB&#39;].url}}?w=1500\"><div class=\"slide-count-wrap\"><span ng-if=\"entry.imageGallery[&#39;en-GB&#39;].length &gt; 1\">{{$index + 1}} / {{entry.imageGallery[&#39;en-GB&#39;].length}}</span></div></div></slick></div><div class=\"wrapper text-wrapper small-wrapper\"><iframe height=\"420px\" id=\"map\" src=\"https://snazzymaps.com/embed/12288\" style=\"border:none;\" width=\"100%\"></iframe><div class=\"text-block\"><h4 class=\"uppercase\"><span ng-if=\"language == &#39;english&#39;\">Contact</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">連絡先</span></h4><h1 class=\"header-font\">Yen London</h1><div link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;en-GB&#39;]\" ng-if=\"language == &#39;english&#39;\"></div><div class=\"japanese\" link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;ja&#39;]\" ng-if=\"language == &#39;japanese&#39;\"></div></div></div><div class=\"tiny-wrapper\" id=\"newsletter-form\"><h3 class=\"header-font center\"><span ng-if=\"language == &#39;english&#39;\">Would you like to receive our newsletter?</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ニューズレターをご希望の方</span></h3><div id=\"mc_embed_signup\"><form action=\"//yen-london.us16.list-manage.com/subscribe/post?u=4c0fdab035ec4be075f5a6882&amp;amp;id=27805fc71c\" class=\"validate\" id=\"mc-embedded-subscribe-form\" method=\"post\" name=\"mc-embedded-subscribe-form\" novalidate=\"\" target=\"_blank\"><div id=\"mc_embed_signup_scroll\"><input class=\"email\" id=\"mce-EMAIL\" name=\"EMAIL\" placeholder=\"Email address\" required=\"\" type=\"email\" value=\"\"><div class=\"clear\" id=\"mce-responses\"><div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div></div><div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"></div><input class=\"button\" id=\"mc-embedded-subscribe\" name=\"subscribe\" type=\"submit\" value=\"Sign up\"></div></form></div><div class=\"clearfix\"></div></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/gallery.html","<md-header></md-header><div class=\"page\" id=\"gallery-page\"><loading></loading><div class=\"wrapper\" ng-if=\"!loading\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery[&#39;en-GB&#39;]\"><img alt=\"{{i.fields.title[&#39;en-GB&#39;]}}\" ng-src=\"{{i.fields.file[&#39;en-GB&#39;].url}}?w=1500\"><div class=\"slide-count-wrap\"><span ng-if=\"entry.imageGallery[&#39;en-GB&#39;].length &gt; 1\">{{$index + 1}} / {{entry.imageGallery[&#39;en-GB&#39;].length}}</span></div></div></slick></div><div class=\"wrapper text-wrapper small-wrapper\"><div class=\"text-block\"><h1 class=\"header-font\"><span ng-if=\"language == &#39;english&#39;\">Gallery</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ギャラリー</span></h1><div link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;en-GB&#39;]\" ng-if=\"language == &#39;english&#39;\"></div><div class=\"japanese\" link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;ja&#39;]\" ng-if=\"language == &#39;japanese&#39;\"></div></div></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/holding.html","<div id=\"holding-page\"><loading></loading><div class=\"wrapper mid-wrapper\" ng-if=\"!loading\"><div class=\"columns twelve\" id=\"logo-block\"><div class=\"logo\"></div><locale></locale></div><div class=\"columns twelve\" id=\"hero-block\"><h1 class=\"super-size\"><span ng-if=\"language == &#39;english&#39;\">OPENING SOON</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">まもなくオープン</span></h1><h2 class=\"uppercase\"><span ng-if=\"language == &#39;english&#39;\">Japanese restaurant specialising in traditional handmade soba noodles</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">自家製粉 手打ち蕎麦を 提供する 日本食レストラン</span></h2><h3>190 STRAND – 5 ARUNDEL STREET – LONDON – WC2R 3DX</h3><div id=\"email-signup\"><h3><span ng-if=\"language == &#39;english&#39;\">Sign up to our newsletter</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ニュースレターにサインアップ</span></h3><div id=\"mc_embed_signup\"><form action=\"//yen-london.us16.list-manage.com/subscribe/post?u=09227f44c1ec7ab1aa14ed4fd&amp;amp;id=580452acde\" class=\"validate\" id=\"mc-embedded-subscribe-form\" method=\"post\" name=\"mc-embedded-subscribe-form\" novalidate=\"\" target=\"_blank\"><div id=\"mc_embed_signup_scroll\"><input class=\"email\" id=\"mce-EMAIL\" name=\"EMAIL\" placeholder=\"Email address\" required=\"\" type=\"email\" value=\"\"><div class=\"clear\" id=\"mce-responses\"><div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div></div><div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"></div><input class=\"button\" id=\"mc-embedded-subscribe\" name=\"subscribe\" type=\"submit\" value=\"Sign up\"></div></form></div></div><h3><a class=\"underline-link\" ng-href=\"mailto:jobs@yen-london-co.uk\" target=\"_blank\"><span ng-if=\"language == &#39;english&#39;\">WORK WITH US</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">一緒に大きな夢を見て働きませんか</span></a></h3></div></div><div id=\"contact-block\"><p><span ng-if=\"language == &#39;english&#39;\">General Enquiries:</span> <span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">問合せ:</span> <a class=\"underline-link\" ng-href=\"mailto:info@yen-london.co.uk\" target=\"_blank\">info@yen-london.co.uk</a></p></div><div class=\"clearfix\"></div><md-footer></md-footer></div>");
$templateCache.put("templates/views/static_pages/home.html","<md-header></md-header><div class=\"page\" id=\"home-page\"><loading></loading><div class=\"wrapper\" ng-if=\"!loading\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery[&#39;en-GB&#39;]\"><img alt=\"{{i.fields.title[&#39;en-GB&#39;]}}\" ng-src=\"{{i.fields.file[&#39;en-GB&#39;].url}}?w=1500\"><div class=\"slide-count-wrap\"><span ng-if=\"entry.imageGallery[&#39;en-GB&#39;].length &gt; 1\">{{$index + 1}} / {{entry.imageGallery[&#39;en-GB&#39;].length}}</span></div></div></slick><div id=\"banner\" markdown-to-html=\"entry.homePageBanner[&#39;en-GB&#39;]\" ng-if=\"entry.homePageBanner[&#39;en-GB&#39;]\"></div></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/menu.html","<md-header></md-header><div class=\"page\" id=\"menu-page\"><loading></loading><div class=\"wrapper\" ng-if=\"!loading\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery[&#39;en-GB&#39;]\"><img alt=\"{{i.fields.title[&#39;en-GB&#39;]}}\" ng-src=\"{{i.fields.file[&#39;en-GB&#39;].url}}?w=1500\"><div class=\"slide-count-wrap\"><span ng-if=\"entry.imageGallery[&#39;en-GB&#39;].length &gt; 1\">{{$index + 1}} / {{entry.imageGallery[&#39;en-GB&#39;].length}}</span></div></div></slick></div><div class=\"wrapper text-wrapper small-wrapper\"><div class=\"text-block\"><h1 class=\"header-font\"><span ng-if=\"language == &#39;english&#39;\">Menu</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">メニュー</span></h1><h4 class=\"date\" ng-bind-html=\"date | date: &#39;EEEE d MMMM yyyy&#39;\"></h4><div class=\"menu-select\"><a class=\"btn\" ng-href=\"{{entry.lunchMenu[&#39;en-GB&#39;].fields.file[&#39;en-GB&#39;].url}}\" ng-if=\"entry.lunchMenu[&#39;en-GB&#39;]\" target=\"_blank\">Lunch Menu</a><a class=\"btn\" ng-href=\"{{entry.dinnerMenu[&#39;en-GB&#39;].fields.file[&#39;en-GB&#39;].url}}\" ng-if=\"entry.dinnerMenu[&#39;en-GB&#39;]\" target=\"_blank\">Dinner Menu</a><a class=\"btn\" ng-href=\"{{entry.desertMenu[&#39;en-GB&#39;].fields.file[&#39;en-GB&#39;].url}}\" ng-if=\"entry.desertMenu[&#39;en-GB&#39;]\" target=\"_blank\">Dessert Menu</a><a class=\"btn\" ng-href=\"{{entry.wineMenu[&#39;en-GB&#39;].fields.file[&#39;en-GB&#39;].url}}\" ng-if=\"entry.wineMenu[&#39;en-GB&#39;]\" target=\"_blank\">Wine & Sake</a><a class=\"btn\" ng-href=\"{{entry.cocktailMenu[&#39;en-GB&#39;].fields.file[&#39;en-GB&#39;].url}}\" ng-if=\"entry.cocktailMenu[&#39;en-GB&#39;]\" target=\"_blank\">Cocktail Menu</a><a class=\"btn\" ng-bind-html=\"entry.seasonalMenu[&#39;en-GB&#39;].fields.title[&#39;en-GB&#39;]\" ng-href=\"{{entry.seasonalMenu[&#39;en-GB&#39;].fields.file[&#39;en-GB&#39;].url}}\" ng-if=\"entry.seasonalMenu[&#39;en-GB&#39;]\" target=\"_blank\"></a></div></div></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/newsletter.html","<left-col></left-col><div class=\"page static_page\" id=\"menu\"><div class=\"wrapper text-wrapper tiny-wrapper\"><loading></loading><div ng-if=\"!loading\"><h1 class=\"header-title underline-title\">Join our newsletter</h1><div class=\"contents\"><p>Get all of the latest news and info on the restaurant and our upcoming events</p><newsletter-signup></newsletter-signup></div></div></div></div>");
$templateCache.put("templates/views/static_pages/reservations.html","<md-header></md-header><div class=\"page\" id=\"reservations-page\"><loading></loading><div class=\"wrapper\" ng-if=\"!loading\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery[&#39;en-GB&#39;]\"><img alt=\"{{i.fields.title[&#39;en-GB&#39;]}}\" ng-src=\"{{i.fields.file[&#39;en-GB&#39;].url}}?w=1500\"><div class=\"slide-count-wrap\"><span ng-if=\"entry.imageGallery[&#39;en-GB&#39;].length &gt; 1\">{{$index + 1}} / {{entry.imageGallery[&#39;en-GB&#39;].length}}</span></div></div></slick></div><div class=\"wrapper text-wrapper small-wrapper\"><div class=\"text-block\"><h1 class=\"header-font\"><span ng-if=\"language == &#39;english&#39;\">Reservations</span><span class=\"japanese\" ng-if=\"language == &#39;japanese&#39;\">ご予約</span></h1><h4 class=\"date\" ng-bind-html=\"date | date: &#39;EEEE d MMMM yyyy&#39;\"></h4><script src=\"//www.opentable.co.uk/widget/reservation/loader?rid=143793&amp;domain=couk&amp;type=standard&amp;theme=standard&amp;lang=en-GB&amp;overlay=false&amp;iframe=false\" type=\"text/javascript\"></script><h2 class=\"header-font\">OR</h2><div link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;en-GB&#39;]\" ng-if=\"language == &#39;english&#39;\"></div><div link-away=\"\" markdown-to-html=\"entry.bodyText[&#39;ja&#39;]\" ng-if=\"language == &#39;japanese&#39;\"></div></div></div></div><md-footer></md-footer>");}]);